export default {
  title: 'Something Went Wrong',
  description: 'Your account has been deactivated. <br> Try using a different login email or contact your'
      + ' company administrator. ',
  backToLogin: 'Back to Login',
};
